import { render, staticRenderFns } from "./dashboard-tabs.vue?vue&type=template&id=ce08fc02&"
import script from "./dashboard-tabs.vue?vue&type=script&lang=js&"
export * from "./dashboard-tabs.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-tabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports